import React, { useState, useMemo } from 'react';
import { Calendar, Clock, Globe, User, Mail, Phone, MessageSquare } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';
import Toast from '../components/ui/Toast';
import { useTranslation } from '../contexts/TranslationContext';
import api from '../utils/api';
import Select from 'react-select';
import { Reveal, PageHero } from './LandingShared';
import { Helmet } from 'react-helmet-async';

const BookingPage = () => {
  const { t, lang } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    country: '',
    phone: '',
    date: '',
    time: '',
    notes: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState(null);

  // Countries list for country dropdown
  const countryOptions = useMemo(() => [
    { value: 'Afghanistan', label: '\u{1F1E6}\u{1F1EB} Afghanistan' },
    { value: 'Albania', label: '\u{1F1E6}\u{1F1F1} Albania' },
    { value: 'Algeria', label: '\u{1F1E9}\u{1F1FF} Algeria' },
    { value: 'Andorra', label: '\u{1F1E6}\u{1F1E9} Andorra' },
    { value: 'Angola', label: '\u{1F1E6}\u{1F1F4} Angola' },
    { value: 'Argentina', label: '\u{1F1E6}\u{1F1F7} Argentina' },
    { value: 'Armenia', label: '\u{1F1E6}\u{1F1F2} Armenia' },
    { value: 'Australia', label: '\u{1F1E6}\u{1F1FA} Australia' },
    { value: 'Austria', label: '\u{1F1E6}\u{1F1F9} Austria' },
    { value: 'Azerbaijan', label: '\u{1F1E6}\u{1F1FF} Azerbaijan' },
    { value: 'Bahrain', label: '\u{1F1E7}\u{1F1ED} Bahrain' },
    { value: 'Bangladesh', label: '\u{1F1E7}\u{1F1E9} Bangladesh' },
    { value: 'Belarus', label: '\u{1F1E7}\u{1F1FE} Belarus' },
    { value: 'Belgium', label: '\u{1F1E7}\u{1F1EA} Belgium' },
    { value: 'Belize', label: '\u{1F1E7}\u{1F1FF} Belize' },
    { value: 'Bolivia', label: '\u{1F1E7}\u{1F1F4} Bolivia' },
    { value: 'Bosnia and Herzegovina', label: '\u{1F1E7}\u{1F1E6} Bosnia and Herzegovina' },
    { value: 'Botswana', label: '\u{1F1E7}\u{1F1FC} Botswana' },
    { value: 'Brazil', label: '\u{1F1E7}\u{1F1F7} Brazil' },
    { value: 'Brunei', label: '\u{1F1E7}\u{1F1F3} Brunei' },
    { value: 'Bulgaria', label: '\u{1F1E7}\u{1F1EC} Bulgaria' },
    { value: 'Cambodia', label: '\u{1F1F0}\u{1F1ED} Cambodia' },
    { value: 'Cameroon', label: '\u{1F1E8}\u{1F1F2} Cameroon' },
    { value: 'Canada', label: '\u{1F1E8}\u{1F1E6} Canada' },
    { value: 'Chile', label: '\u{1F1E8}\u{1F1F1} Chile' },
    { value: 'China', label: '\u{1F1E8}\u{1F1F3} China' },
    { value: 'Colombia', label: '\u{1F1E8}\u{1F1F4} Colombia' },
    { value: 'Costa Rica', label: '\u{1F1E8}\u{1F1F7} Costa Rica' },
    { value: 'Croatia', label: '\u{1F1ED}\u{1F1F7} Croatia' },
    { value: 'Cyprus', label: '\u{1F1E8}\u{1F1FE} Cyprus' },
    { value: 'Czech Republic', label: '\u{1F1E8}\u{1F1FF} Czech Republic' },
    { value: 'Denmark', label: '\u{1F1E9}\u{1F1F0} Denmark' },
    { value: 'Ecuador', label: '\u{1F1EA}\u{1F1E8} Ecuador' },
    { value: 'Egypt', label: '\u{1F1EA}\u{1F1EC} Egypt' },
    { value: 'El Salvador', label: '\u{1F1F8}\u{1F1FB} El Salvador' },
    { value: 'Estonia', label: '\u{1F1EA}\u{1F1EA} Estonia' },
    { value: 'Ethiopia', label: '\u{1F1EA}\u{1F1F9} Ethiopia' },
    { value: 'Finland', label: '\u{1F1EB}\u{1F1EE} Finland' },
    { value: 'France', label: '\u{1F1EB}\u{1F1F7} France' },
    { value: 'Georgia', label: '\u{1F1EC}\u{1F1EA} Georgia' },
    { value: 'Germany', label: '\u{1F1E9}\u{1F1EA} Germany' },
    { value: 'Ghana', label: '\u{1F1EC}\u{1F1ED} Ghana' },
    { value: 'Greece', label: '\u{1F1EC}\u{1F1F7} Greece' },
    { value: 'Guatemala', label: '\u{1F1EC}\u{1F1F9} Guatemala' },
    { value: 'Honduras', label: '\u{1F1ED}\u{1F1F3} Honduras' },
    { value: 'Hong Kong', label: '\u{1F1ED}\u{1F1F0} Hong Kong' },
    { value: 'Hungary', label: '\u{1F1ED}\u{1F1FA} Hungary' },
    { value: 'Iceland', label: '\u{1F1EE}\u{1F1F8} Iceland' },
    { value: 'India', label: '\u{1F1EE}\u{1F1F3} India' },
    { value: 'Indonesia', label: '\u{1F1EE}\u{1F1E9} Indonesia' },
    { value: 'Iran', label: '\u{1F1EE}\u{1F1F7} Iran' },
    { value: 'Iraq', label: '\u{1F1EE}\u{1F1F6} Iraq' },
    { value: 'Ireland', label: '\u{1F1EE}\u{1F1EA} Ireland' },
    { value: 'Israel', label: '\u{1F1EE}\u{1F1F1} Israel' },
    { value: 'Italy', label: '\u{1F1EE}\u{1F1F9} Italy' },
    { value: 'Japan', label: '\u{1F1EF}\u{1F1F5} Japan' },
    { value: 'Jordan', label: '\u{1F1EF}\u{1F1F4} Jordan' },
    { value: 'Kazakhstan', label: '\u{1F1F0}\u{1F1FF} Kazakhstan' },
    { value: 'Kenya', label: '\u{1F1F0}\u{1F1EA} Kenya' },
    { value: 'South Korea', label: '\u{1F1F0}\u{1F1F7} South Korea' },
    { value: 'Kuwait', label: '\u{1F1F0}\u{1F1FC} Kuwait' },
    { value: 'Laos', label: '\u{1F1F1}\u{1F1E6} Laos' },
    { value: 'Latvia', label: '\u{1F1F1}\u{1F1FB} Latvia' },
    { value: 'Lebanon', label: '\u{1F1F1}\u{1F1E7} Lebanon' },
    { value: 'Libya', label: '\u{1F1F1}\u{1F1FE} Libya' },
    { value: 'Liechtenstein', label: '\u{1F1F1}\u{1F1EE} Liechtenstein' },
    { value: 'Lithuania', label: '\u{1F1F1}\u{1F1F9} Lithuania' },
    { value: 'Luxembourg', label: '\u{1F1F1}\u{1F1FA} Luxembourg' },
    { value: 'Macau', label: '\u{1F1F2}\u{1F1F4} Macau' },
    { value: 'Malaysia', label: '\u{1F1F2}\u{1F1FE} Malaysia' },
    { value: 'Malta', label: '\u{1F1F2}\u{1F1F9} Malta' },
    { value: 'Mauritius', label: '\u{1F1F2}\u{1F1FA} Mauritius' },
    { value: 'Mexico', label: '\u{1F1F2}\u{1F1FD} Mexico' },
    { value: 'Monaco', label: '\u{1F1F2}\u{1F1E8} Monaco' },
    { value: 'Mongolia', label: '\u{1F1F2}\u{1F1F3} Mongolia' },
    { value: 'Morocco', label: '\u{1F1F2}\u{1F1E6} Morocco' },
    { value: 'Mozambique', label: '\u{1F1F2}\u{1F1FF} Mozambique' },
    { value: 'Myanmar', label: '\u{1F1F2}\u{1F1F2} Myanmar' },
    { value: 'Nepal', label: '\u{1F1F3}\u{1F1F5} Nepal' },
    { value: 'Netherlands', label: '\u{1F1F3}\u{1F1F1} Netherlands' },
    { value: 'New Zealand', label: '\u{1F1F3}\u{1F1FF} New Zealand' },
    { value: 'Nicaragua', label: '\u{1F1F3}\u{1F1EE} Nicaragua' },
    { value: 'Nigeria', label: '\u{1F1F3}\u{1F1EC} Nigeria' },
    { value: 'Norway', label: '\u{1F1F3}\u{1F1F4} Norway' },
    { value: 'Oman', label: '\u{1F1F4}\u{1F1F2} Oman' },
    { value: 'Pakistan', label: '\u{1F1F5}\u{1F1F0} Pakistan' },
    { value: 'Panama', label: '\u{1F1F5}\u{1F1E6} Panama' },
    { value: 'Paraguay', label: '\u{1F1F5}\u{1F1FE} Paraguay' },
    { value: 'Peru', label: '\u{1F1F5}\u{1F1EA} Peru' },
    { value: 'Philippines', label: '\u{1F1F5}\u{1F1ED} Philippines' },
    { value: 'Poland', label: '\u{1F1F5}\u{1F1F1} Poland' },
    { value: 'Portugal', label: '\u{1F1F5}\u{1F1F9} Portugal' },
    { value: 'Qatar', label: '\u{1F1F6}\u{1F1E6} Qatar' },
    { value: 'Romania', label: '\u{1F1F7}\u{1F1F4} Romania' },
    { value: 'Russia', label: '\u{1F1F7}\u{1F1FA} Russia' },
    { value: 'Saudi Arabia', label: '\u{1F1F8}\u{1F1E6} Saudi Arabia' },
    { value: 'Serbia', label: '\u{1F1F7}\u{1F1F8} Serbia' },
    { value: 'Singapore', label: '\u{1F1F8}\u{1F1EC} Singapore' },
    { value: 'Slovakia', label: '\u{1F1F8}\u{1F1F0} Slovakia' },
    { value: 'Slovenia', label: '\u{1F1F8}\u{1F1EE} Slovenia' },
    { value: 'South Africa', label: '\u{1F1FF}\u{1F1E6} South Africa' },
    { value: 'Spain', label: '\u{1F1EA}\u{1F1F8} Spain' },
    { value: 'Sri Lanka', label: '\u{1F1F1}\u{1F1F0} Sri Lanka' },
    { value: 'Sweden', label: '\u{1F1F8}\u{1F1EA} Sweden' },
    { value: 'Switzerland', label: '\u{1F1E8}\u{1F1ED} Switzerland' },
    { value: 'Taiwan', label: '\u{1F1F9}\u{1F1FC} Taiwan' },
    { value: 'Thailand', label: '\u{1F1F9}\u{1F1ED} Thailand' },
    { value: 'Tunisia', label: '\u{1F1F9}\u{1F1F3} Tunisia' },
    { value: 'Turkey', label: '\u{1F1F9}\u{1F1F7} Turkey' },
    { value: 'Uganda', label: '\u{1F1FA}\u{1F1EC} Uganda' },
    { value: 'Ukraine', label: '\u{1F1FA}\u{1F1E6} Ukraine' },
    { value: 'United Arab Emirates', label: '\u{1F1E6}\u{1F1EA} United Arab Emirates' },
    { value: 'United Kingdom', label: '\u{1F1EC}\u{1F1E7} United Kingdom' },
    { value: 'United States', label: '\u{1F1FA}\u{1F1F8} United States' },
    { value: 'Uruguay', label: '\u{1F1FA}\u{1F1FE} Uruguay' },
    { value: 'Uzbekistan', label: '\u{1F1FA}\u{1F1FF} Uzbekistan' },
    { value: 'Venezuela', label: '\u{1F1FB}\u{1F1EA} Venezuela' },
    { value: 'Vietnam', label: '\u{1F1FB}\u{1F1F3} Vietnam' },
    { value: 'Zambia', label: '\u{1F1FF}\u{1F1F2} Zambia' },
    { value: 'Zimbabwe', label: '\u{1F1FF}\u{1F1FC} Zimbabwe' },
  ], []);

  // Custom styles for react-select
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.5)' : 'none',
      '&:hover': {
        borderColor: '#3b82f6'
      }
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#dbeafe' : 'white',
      color: state.isSelected ? 'white' : '#111827',
      cursor: 'pointer'
    })
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Send booking to backend
      await api.post(`/api/bookings/create`, {
        ...formData,
        language: lang
      });

      setSubmitted(true);

      // Reset form after 5 seconds
      setTimeout(() => {
        setSubmitted(false);
        setFormData({
          name: '',
          email: '',
          country: '',
          phone: '',
          date: '',
          time: '',
          notes: ''
        });
      }, 5000);
    } catch (error) {
      console.error('Error submitting booking:', error);
      setToast({ message: t('booking.error'), type: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <title>Book a Consultation — Cogent Platform</title>
        <meta name="description" content="Schedule a consultation with Cogent Asset Management. Book a meeting with our investment team to discuss your portfolio and financial goals." />
        <link rel="canonical" href="https://cogentplatform.com/booking" />
      </Helmet>
      {toast && <Toast message={toast.message} type={toast.type} onDismiss={() => setToast(null)} />}
      <Navbar />
      <main className="flex-grow">
        {/* Hero Header */}
        <PageHero title={t('booking.title')} subtitle={t('booking.subtitle')} />

        {/* Main Content */}
        <div className="bg-gradient-to-b from-white to-slate-50 py-12 sm:py-16">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            {submitted ? (
              /* Success Message */
              <Reveal>
                <div className="bg-green-50 rounded-2xl border border-green-200 shadow-sm p-8 text-center max-w-2xl mx-auto">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-bold text-green-800 mb-2">{t('booking.success')}</h2>
                  <p className="text-green-700">{t('booking.successMessage')}</p>
                </div>
              </Reveal>
            ) : (
              <div className="grid md:grid-cols-2 gap-8">
                {/* Booking Form */}
                <Reveal delay={0}>
                  <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden">
                    {/* Gradient accent line */}
                    <div className="h-1 bg-gradient-to-r from-blue-600 to-cyan-600" />
                    <div className="p-8">
                      <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Name */}
                        <div>
                          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                            <User size={16} />
                            {t('booking.name')}
                          </label>
                          <input
                            type="text"
                            name="name"
                            required
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder={t('booking.namePlaceholder')}
                          />
                        </div>

                        {/* Email */}
                        <div>
                          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                            <Mail size={16} />
                            {t('booking.email')}
                          </label>
                          <input
                            type="email"
                            name="email"
                            required
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder={t('booking.emailPlaceholder')}
                          />
                        </div>

                        {/* Country - Searchable */}
                        <div>
                          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                            <Globe size={16} />
                            {t('booking.country')}
                          </label>
                          <Select
                            options={countryOptions}
                            value={countryOptions.find(c => c.value === formData.country)}
                            onChange={(selected) => setFormData({ ...formData, country: selected?.value || '' })}
                            placeholder={t('booking.selectCountry')}
                            isClearable
                            isSearchable
                            styles={selectStyles}
                            className="react-select-container"
                            classNamePrefix="react-select"
                          />
                        </div>

                        {/* Phone */}
                        <div>
                          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                            <Phone size={16} />
                            {t('booking.phone')}
                          </label>
                          <input
                            type="tel"
                            name="phone"
                            required
                            value={formData.phone}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder={t('booking.phonePlaceholder')}
                          />
                          <p className="text-xs text-gray-500 mt-1">
                            {t('booking.phoneHint')}
                          </p>
                        </div>

                        {/* Date */}
                        <div>
                          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                            <Calendar size={16} />
                            {t('booking.date')}
                          </label>
                          <input
                            type="date"
                            name="date"
                            required
                            value={formData.date}
                            onChange={handleChange}
                            min={new Date().toISOString().split('T')[0]}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          />
                        </div>

                        {/* Time */}
                        <div>
                          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                            <Clock size={16} />
                            {t('booking.time')}
                          </label>
                          <select
                            name="time"
                            required
                            value={formData.time}
                            onChange={handleChange}
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="">{t('booking.selectTime')}</option>
                            <optgroup label={t('booking.morning')}>
                              <option value="09:00">09:00 AM</option>
                              <option value="10:00">10:00 AM</option>
                              <option value="11:00">11:00 AM</option>
                              <option value="12:00">12:00 PM</option>
                            </optgroup>
                            <optgroup label={t('booking.afternoon')}>
                              <option value="14:00">02:00 PM</option>
                              <option value="15:00">03:00 PM</option>
                              <option value="16:00">04:00 PM</option>
                              <option value="17:00">05:00 PM</option>
                            </optgroup>
                          </select>
                          <p className="text-xs text-gray-500 mt-1">
                            {'\u{1F30F}'} {t('booking.timezoneNote')}
                          </p>
                        </div>

                        {/* Notes */}
                        <div>
                          <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
                            <MessageSquare size={16} />
                            {t('booking.notes')}
                          </label>
                          <textarea
                            name="notes"
                            value={formData.notes}
                            onChange={handleChange}
                            rows="3"
                            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder={t('booking.notesPlaceholder')}
                          />
                        </div>

                        {/* Submit Button */}
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 disabled:from-gray-400 disabled:to-gray-400 disabled:cursor-not-allowed text-white font-semibold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
                        >
                          {isSubmitting ? t('booking.submitting') : t('booking.submit')}
                        </button>
                      </form>
                    </div>
                  </div>
                </Reveal>

                {/* Info Panel */}
                <div className="space-y-6">
                  {/* Available Times with Timezone Conversion */}
                  <Reveal delay={100}>
                    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                      {/* Gradient accent line */}
                      <div className="h-1 bg-gradient-to-r from-blue-600 to-cyan-600" />
                      <div className="p-6">
                        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                          <Clock className="text-blue-600" />
                          {t('booking.availableTimes')}
                        </h3>

                        {/* Timezone Info */}
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                          <p className="text-sm text-blue-900 font-medium">{'\u{1F30F}'} {t('booking.timezoneNote')}</p>
                        </div>

                        {/* Morning Slot */}
                        <div className="mb-4">
                          <div className="flex items-start gap-3 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
                            <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                            <div className="flex-1">
                              <p className="font-bold text-gray-900 mb-1">{'\u{1F305}'} {t('booking.morning')}</p>
                              <p className="text-sm font-medium text-blue-900">9:00 AM - 12:00 PM</p>
                              <p className="text-xs text-gray-600">{'\u{1F1F2}\u{1F1FE}'} {t('booking.malaysiaTime')}</p>
                              <div className="mt-2 pt-2 border-t border-blue-200">
                                <p className="text-xs text-gray-700 font-medium mb-1">{t('booking.southAmericaNote')}:</p>
                                <p className="text-xs text-gray-600">{'\u{1F1E6}\u{1F1F7}'} Argentina/Chile: 10:00 PM - 1:00 AM (prev. day)</p>
                                <p className="text-xs text-gray-600">{'\u{1F1E8}\u{1F1F4}'} Colombia/Peru: 8:00 PM - 11:00 PM (prev. day)</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Afternoon Slot */}
                        <div className="mb-4">
                          <div className="flex items-start gap-3 p-4 bg-gradient-to-r from-orange-50 to-yellow-50 rounded-lg border border-orange-200">
                            <div className="w-2 h-2 bg-orange-600 rounded-full mt-2"></div>
                            <div className="flex-1">
                              <p className="font-bold text-gray-900 mb-1">{'\u{1F31E}'} {t('booking.afternoon')}</p>
                              <p className="text-sm font-medium text-orange-900">2:00 PM - 5:00 PM</p>
                              <p className="text-xs text-gray-600">{'\u{1F1F2}\u{1F1FE}'} {t('booking.malaysiaTime')}</p>
                              <div className="mt-2 pt-2 border-t border-orange-200">
                                <p className="text-xs text-gray-700 font-medium mb-1">{t('booking.southAmericaNote')}:</p>
                                <p className="text-xs text-gray-600">{'\u{1F1E6}\u{1F1F7}'} Argentina/Chile: 1:00 AM - 4:00 AM (same day)</p>
                                <p className="text-xs text-gray-600">{'\u{1F1E8}\u{1F1F4}'} Colombia/Peru: 11:00 PM - 2:00 AM (prev./same day)</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <p className="text-xs text-gray-500 text-center mt-3">
                          {t('booking.weekdays')}
                        </p>
                      </div>
                    </div>
                  </Reveal>

                  {/* Contact Info */}
                  <Reveal delay={200}>
                    <div className="bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl shadow-lg p-6 text-white">
                      <h3 className="text-xl font-bold mb-4">
                        {t('booking.needHelp')}
                      </h3>
                      <div className="space-y-3">
                        <div className="flex items-center gap-3">
                          <Mail size={20} />
                          <a href="mailto:operations@cogentplatform.com" className="text-white hover:underline">
                            operations@cogentplatform.com
                          </a>
                        </div>
                        <div className="flex items-center gap-3">
                          <Phone size={20} />
                          <a href="tel:+60874410750" className="text-white hover:underline">
                            Malaysia +60 87-410 750
                          </a>
                        </div>
                      </div>
                    </div>
                  </Reveal>

                  {/* Additional Info */}
                  <Reveal delay={300}>
                    <div className="bg-yellow-50 rounded-2xl border border-yellow-200 shadow-sm p-4">
                      <p className="text-sm text-yellow-800">
                        {t('booking.tip')}
                      </p>
                    </div>
                  </Reveal>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BookingPage;
